import { useState } from "react";
import { Menu, X } from "lucide-react";

export const LINKS = [
  { id: "#home", label: "Home" },
  { id: "#services", label: "Services" },
  { id: "#about", label: "About" },
  { id: "#why-offshore", label: "Why Offshore" },
  { id: "#gcc-execution", label: "GCC Execution" },
  { id: "#contact", label: "Contact" },
];

export const LogoMark = ({ className = "h-10 w-auto" }) => (
  <img src="/crestbridge_logo_cropped.png" alt="Crestbridge" className={className} />
);

export default function Nav({ onNavigate }) {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    onNavigate(id);
  };

  return (
    <header className="fixed top-0 z-50 w-full border-b border-line bg-paper/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <button
          onClick={() => go("#home")}
          className="flex items-center gap-3"
          data-testid="nav-logo"
        >
          <LogoMark className="h-11 w-auto" />
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.id}
              onClick={(e) => {
                e.preventDefault();
                go(l.id);
              }}
              data-testid={`nav-link-${l.id.slice(1)}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-ink/70 transition-colors duration-300 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <button
          className="lg:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav className="border-t border-line bg-paper lg:hidden" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.id}
              onClick={(e) => {
                e.preventDefault();
                go(l.id);
              }}
              data-testid={`nav-mobile-link-${l.id.slice(1)}`}
              className="block w-full border-b border-line px-6 py-4 text-left font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}
